import { Inject } from '../../Application';
import { Constants } from '../../Contract/Application';
import * as DOMPurify from 'dompurify';
export function Component(templateUrl, styleCss) {
    var resolveTemplate = function (self) {
        var http = Inject.Instance.resolve(Constants.Server);
        var library = Inject.Instance.resolve(Constants.Library);
        http.get(styleCss, null, function (styles) {
            var styleSanitize = DOMPurify.sanitize(styles, { RETURN_DOM_FRAGMENT: true, FORCE_BODY: true, FORBID_TAGS: ['style'] });
            library.dom.find('head').append("<style type='text/css'>".concat(styleSanitize.textContent, "</style>"));
            http.get(templateUrl, null, function (response) {
                var responseSanitize = DOMPurify.sanitize(response, { RETURN_DOM: true, CUSTOM_ELEMENT_HANDLING: {
                        tagNameCheck: /^wm-/,
                        allowCustomizedBuiltInElements: true,
                    } });
                library.dom.find('body').append(responseSanitize.innerHTML);
                self.executeLoad();
            });
        });
    };
    return function (target) {
        var newConstructor = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            target.apply(this, args);
            resolveTemplate(this);
        };
        newConstructor.prototype = Object.create(target.prototype);
        newConstructor.prototype.constructor = target;
        return newConstructor;
    };
}
